import { render, staticRenderFns } from "./TemporaryCounting.vue?vue&type=template&id=4c61d1a5"
import script from "./TemporaryCounting.vue?vue&type=script&lang=js"
export * from "./TemporaryCounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports